import React from "react";

function withToolTip(Component) {
	return class withToolTip extends React.Component {
		state = { hovering: false };
		mouseOver = () => this.setState({ hovering: true });
		mouseOut = () => this.setState({ hovering: false });
		render() {
			return (
				<div
					onMouseEnter={this.mouseOver}
					onMouseLeave={this.mouseOut}
					style={{ minHeight: "auto" }}
				>
					<Component
						hovering={this.state.hovering}
						children={this.props.children}
						icon={this.props.icon}
						hideIcon={this.props.hideIcon}
						ZIndex={this.props.ZIndex}
						width={this.props.width}
						adjustParentStyle={this.props.adjustParentStyle}
						position={this.props.position}
					/>
				</div>
			);
		}
	};
}
export default withToolTip;
